import { openPrintWindow, esc } from "../../lib/print";
import { toHtml, absolutize } from "../../lib/richText";
import dayjs from "dayjs";

const attr = (s) => esc(s).replace(/"/g, "&quot;");

/** Print an approved patient education handout on the clinic letterhead. */
export function printHandout(h, clientName) {
  const paras = `<style>.ho p{margin:0 0 10px;font-size:13.5px;line-height:1.55}.ho h2{font-size:16px;margin:14px 0 6px}.ho h3{font-size:14.5px;margin:12px 0 4px}
    .ho ul,.ho ol{padding-left:20px;margin:0 0 10px;font-size:13.5px;line-height:1.55}.ho img{max-width:100%;height:auto;border-radius:8px;margin:6px 0}</style>
    <div class="ho">${absolutize(toHtml(h.body))}</div>`;
  const links = (h.links || []).map((l) => `<li style="margin:4px 0;font-size:12.5px"><b>${esc(l.label)}</b><br/><a href="${attr(l.url)}">${esc(l.url)}</a></li>`).join("");
  const body = `<h1>${esc(h.title)}</h1>
    <div class="meta">Prepared for ${esc(clientName)} on ${esc(dayjs().format("MMM D, YYYY"))}</div>
    <div style="margin-top:14px">${paras}</div>
    ${links ? `<div class="label" style="margin-top:14px">Trusted resources</div><ul style="padding-left:18px">${links}</ul>` : ""}
    <div class="meta" style="margin-top:18px">Approved by ${esc(h.approved_by_name)}. This handout is for education only and does not replace advice from your care team. If you are in crisis, call or text 988, or call 911.</div>`;
  openPrintWindow(h.title, body);
}
